import { useEffect, useState } from "react";

const usePreferredCamera = () => {
  const [cameraId, setCameraId] = useState<string | null>();

  const getCameraCapabilities = async (deviceId: string) => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: deviceId } },
      });

      const track = stream.getVideoTracks()[0];
      const capabilities = track?.getCapabilities();
      track?.stop(); // Stop the stream immediately after getting capabilities

      return capabilities;
    } catch (error) {
      console.error(`Failed to get capabilities for camera ${deviceId}:`, error);
      return null;
    }
  };

  const isCameraPreferred = async (deviceId: string) => {
    const capabilities = await getCameraCapabilities(deviceId);
    if (!capabilities) return false;

    // We want to use the back camera with continuous focus mode
    const isPreferred =
      capabilities.facingMode?.includes("environment") && (capabilities as any)?.focusMode?.includes("continuous");
    return isPreferred;
  };

  const getPreferredBackCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((device) => device.kind === "videoinput");

      for (const device of videoDevices.reverse()) {
        if (await isCameraPreferred(device.deviceId)) {
          return device.deviceId;
        }
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    getPreferredBackCamera().then((deviceId) => {
      setCameraId(deviceId);
    });
  }, []);

  return cameraId;
};
export default usePreferredCamera;
